import React, { useRef } from 'react';
import { motion, useMotionValue, useReducedMotion, useSpring, useTransform } from 'framer-motion';
import MarketMasterbatchVisual from './MarketMasterbatchVisual';
import { cardEntrance, getCardTiltSpring } from '../motion/variants';

const ACCENTS = ['gold', 'blue', 'green', 'navy'];

export function accentForMarket(index) {
  return ACCENTS[index % ACCENTS.length];
}

const cardEntranceVariant = {
  hidden: (i) => cardEntrance(i ?? 0).hidden,
  visible: (i) => cardEntrance(i).visible,
};

export default function MarketCard3D({ market, index, accent }) {
  const reduceMotion = useReducedMotion();
  const ref = useRef(null);
  const px = useMotionValue(0);
  const py = useMotionValue(0);
  const tilt = getCardTiltSpring();
  const rotateX = useSpring(useTransform(py, [-0.5, 0.5], [10, -10]), tilt);
  const rotateY = useSpring(useTransform(px, [-0.5, 0.5], [-10, 10]), tilt);

  const onMove = (e) => {
    if (reduceMotion || !ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    px.set((e.clientX - rect.left) / rect.width - 0.5);
    py.set((e.clientY - rect.top) / rect.height - 0.5);
  };

  const onLeave = () => {
    px.set(0);
    py.set(0);
  };

  return (
    <motion.article
      ref={ref}
      className="markets-v2__card"
      data-accent={accent}
      custom={index}
      variants={cardEntranceVariant}
      style={
        reduceMotion
          ? { transformStyle: 'preserve-3d' }
          : { rotateX, rotateY, transformStyle: 'preserve-3d' }
      }
      onMouseMove={onMove}
      onMouseLeave={onLeave}
    >
      <span className="markets-v2__card-border" aria-hidden="true" />
      <span className="markets-v2__card-shine" aria-hidden="true" />

      <div className="markets-v2__card-top">
        <span className="markets-v2__no">{market.no}</span>
        <span className={`markets-v2__trend markets-v2__trend--${market.trendDir || 'up'}`}>
          {market.trend}
        </span>
      </div>

      <MarketMasterbatchVisual accent={accent} title={market.title} image={market.image} />

      <div className="markets-v2__card-body">
        <h4>{market.title}</h4>
        <p>{market.desc}</p>
        <span className="markets-v2__trend-label">{market.trendLabel}</span>
      </div>
    </motion.article>
  );
}
